export const STYLE_PREVIEW_BASE = 'https://media.easy-peasy.ai/previews/style';

export function styleSlug(label: string): string {
  return label
    .toLowerCase()
    .replace(/[/°]/g, '-')
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '')
    .replace(/-+/g, '-');
}

export function stylePreviewUrl(label: string): string {
  return `${STYLE_PREVIEW_BASE}/${styleSlug(label)}.webp?v=2`;
}

export interface StyleOption {
  value: string;
  emoji: string;
  previewUrl?: string;
}

export const PANORAMA_STYLE_VALUE = '360° Panorama';

export const STYLE_OPTIONS: StyleOption[] = [
  { value: 'None', emoji: '🚫' },
  // { value: '4K', emoji: '🖼️', previewUrl: stylePreviewUrl('4K') },
  {
    value: 'Oil Painting',
    emoji: '🎨',
    previewUrl: stylePreviewUrl('Oil Painting'),
  },
  {
    value: 'Digital art',
    emoji: '💻',
    previewUrl: stylePreviewUrl('Digital art'),
  },
  {
    value: 'Detailed photo',
    emoji: '📸',
    previewUrl: stylePreviewUrl('Detailed photo'),
  },
  { value: 'Cyberpunk', emoji: '🤖', previewUrl: stylePreviewUrl('Cyberpunk') },
  {
    value: 'Artstation',
    emoji: '🎮',
    previewUrl: stylePreviewUrl('Artstation'),
  },
  {
    value: 'Watercolor',
    emoji: '💧',
    previewUrl: stylePreviewUrl('Watercolor'),
  },
  {
    value: 'Pencil drawing',
    emoji: '✏️',
    previewUrl: stylePreviewUrl('Pencil drawing'),
  },
  {
    value: 'Concept art',
    emoji: '🎭',
    previewUrl: stylePreviewUrl('Concept art'),
  },
  { value: 'Cartoon', emoji: '🦸', previewUrl: stylePreviewUrl('Cartoon') },
  { value: 'Anime', emoji: '🌸', previewUrl: stylePreviewUrl('Anime') },
  { value: 'Mosaic', emoji: '🧩', previewUrl: stylePreviewUrl('Mosaic') },
  {
    value: '3D Render',
    emoji: '🧊',
    previewUrl: stylePreviewUrl('3D Render'),
  },
  {
    value: 'Classicism',
    emoji: '🏛️',
    previewUrl: stylePreviewUrl('Classicism'),
  },
  {
    value: 'Impressionism',
    emoji: '🌅',
    previewUrl: stylePreviewUrl('Impressionism'),
  },
  {
    value: 'Renaissance',
    emoji: '👑',
    previewUrl: stylePreviewUrl('Renaissance'),
  },
  { value: 'Baroque', emoji: '💎', previewUrl: stylePreviewUrl('Baroque') },
  { value: 'Medieval', emoji: '🏰', previewUrl: stylePreviewUrl('Medieval') },
  {
    value: 'Studio Photo',
    emoji: '📷',
    previewUrl: stylePreviewUrl('Studio Photo'),
  },
  {
    value: 'Portrait Photo',
    emoji: '👤',
    previewUrl: stylePreviewUrl('Portrait Photo'),
  },
  {
    value: 'Iconography',
    emoji: '🛐',
    previewUrl: stylePreviewUrl('Iconography'),
  },
  { value: 'Sticker', emoji: '🏷️', previewUrl: stylePreviewUrl('Sticker') },
  { value: 'Pixar 3D', emoji: '🧸', previewUrl: stylePreviewUrl('Pixar 3D') },
  {
    value: 'Studio Ghibli',
    emoji: '🌿',
    previewUrl: stylePreviewUrl('Studio Ghibli'),
  },
  {
    value: 'Pixel Art',
    emoji: '👾',
    previewUrl: stylePreviewUrl('Pixel Art'),
  },
  { value: 'Low Poly', emoji: '📐', previewUrl: stylePreviewUrl('Low Poly') },
  {
    value: 'Isometric',
    emoji: '📦',
    previewUrl: stylePreviewUrl('Isometric'),
  },
  {
    value: 'Claymation',
    emoji: '🗿',
    previewUrl: stylePreviewUrl('Claymation'),
  },
  { value: 'Pop Art', emoji: '🥫', previewUrl: stylePreviewUrl('Pop Art') },
  // { value: 'Ukiyo-e', emoji: '🗾', previewUrl: stylePreviewUrl('Ukiyo-e') },
  { value: 'Art Deco', emoji: '🏙️', previewUrl: stylePreviewUrl('Art Deco') },
  {
    value: 'Art Nouveau',
    emoji: '🌹',
    previewUrl: stylePreviewUrl('Art Nouveau'),
  },
  {
    value: 'Surrealism',
    emoji: '🌀',
    previewUrl: stylePreviewUrl('Surrealism'),
  },
  { value: 'Bauhaus', emoji: '🔷', previewUrl: stylePreviewUrl('Bauhaus') },
  { value: 'Film Noir', emoji: '🎬', previewUrl: stylePreviewUrl('Film Noir') },
  { value: 'Polaroid', emoji: '🎞️', previewUrl: stylePreviewUrl('Polaroid') },
  {
    value: 'Synthwave',
    emoji: '🌆',
    previewUrl: stylePreviewUrl('Synthwave'),
  },
  {
    value: 'Fashion Editorial',
    emoji: '👗',
    previewUrl: stylePreviewUrl('Fashion Editorial'),
  },
  {
    value: 'Comic Book',
    emoji: '💥',
    previewUrl: stylePreviewUrl('Comic Book'),
  },
  { value: 'Manga', emoji: '📖', previewUrl: stylePreviewUrl('Manga') },
  { value: 'Line Art', emoji: '✒️', previewUrl: stylePreviewUrl('Line Art') },
  {
    value: 'Charcoal drawing',
    emoji: '🖤',
    previewUrl: stylePreviewUrl('Charcoal drawing'),
  },
  {
    value: "Children's Book",
    emoji: '🧚',
    previewUrl: stylePreviewUrl("Children's Book"),
  },
  { value: 'Graffiti', emoji: '🖌️', previewUrl: stylePreviewUrl('Graffiti') },
  {
    value: 'Caricature',
    emoji: '🤹',
    previewUrl: stylePreviewUrl('Caricature'),
  },
  // { value: 'Muppet', emoji: '🐸', previewUrl: stylePreviewUrl('Muppet') },
  { value: PANORAMA_STYLE_VALUE, emoji: '🌐' },
];
